export default __webpack_public_path__ + "static/media/4.8ae15488.PNG";